module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('p', {
    staticClass: "ChapterHeader"
  }, [_vm._v("Table of Contents")]), _vm._v(" "), _c('p', {
    staticClass: "TOC-copy ParaOverride-2"
  }, [_c('a', {
    attrs: {
      "href": "#/07prlg"
    }
  }, [_vm._v("Prologue")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/ch01"
    }
  }, [_vm._v("1.     Skipper’s Point")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/ch02"
    }
  }, [_vm._v("2.     Gurney and Red")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/ch03"
    }
  }, [_vm._v("3.     Paradise")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.     Old Resident")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5.     A Hermit")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6.     A Dueler’s Edge")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7.     The Angel of Scotts Branch")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8.     The House on Honeysuckle Way")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9.     A Roll from the Hay")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10.   Just a Tad Gone Bad")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11.   Children of Summer")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12.   Can’t Get It Back")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13.   Sunny’s Knights")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14.   Storm of Darkness")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15.   Hell in Paradise")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/ch16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16.   Certain Men")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/ch17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17.   Franco’s Tutorial")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/ch18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18.   Dark Places")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/ch19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19.   Some Are Just Visiting")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/ch20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20.   Winter’s Map")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/ch21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21.   Sunny’s Return")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/ch22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22.   Junebug’s Lament")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/ch23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23.   Box of Ghosts")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/ch24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24.   Coco Friday’s Rhythm")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/ch25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25.   Midnight’s Fever Dream")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/ch26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26.   Searching for Innocence")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/ch27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27.   Jake’s Place")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/ch28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28.   Blood Brothers Forever")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/ch29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29.   Trinity River Bottom Ruminations")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/ch30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30.   The Heart of Dixie")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/ch31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31.   Xavier")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/ch32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32.   The Mouse Trap Confessional")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/ch33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33.   Receiving the Cane")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/ch34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34.   The Devil Sang")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/ch35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35.   The Devil’s Domain")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/ch36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36.   Children after Midnight")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/ch37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37.   Right the Wrong")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/ch38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38.   Hermit of Paradise")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-copy ParaOverride-2"
  }, [_c('span', {
    attrs: {
      "href": "#/ch39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowlegments")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-copy ParaOverride-2"
  }, [_c('span', {
    attrs: {
      "href": "#/ch40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30e735d7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/06-toc.vue
// module id = 72
// module chunks = 0